import {useState} from "react";
import {addDoc, collection, getDocs, query, where} from "@firebase/firestore";
import {db} from "../config"
import {EntryData} from "../Types/entryData";





const useAddEntry = (propImageUrls: string[] | null) => {
    const [isPending, setIsPending] = useState(false);

    let addedEntryId = "";
    const imageUrls = propImageUrls;


    const addNewEntry = async (entryData: EntryData) => {
        let success = true;

        setIsPending(true);
        try {
            const q = query(collection(db, "Entries"), where("email", "==", entryData.email));
            const docs = await getDocs(q);
            if (docs.docs.length === 0) {
                const doc = await addDoc(collection(db, 'Entries'), {
                    ...entryData,
                    imageUrl: imageUrls,
                });
            addedEntryId = doc.id;
            }
        } catch (err) {
            success = false;
            console.log(err);
        }
        setIsPending(false);
        return {success, addedEntryId};
    };
    return {addNewEntry, isPending};
};

export default useAddEntry;
